import { render, staticRenderFns } from "./DateProfit.vue?vue&type=template&id=3ba7986c&scoped=true&"
import script from "./DateProfit.vue?vue&type=script&lang=js&"
export * from "./DateProfit.vue?vue&type=script&lang=js&"
import style0 from "./DateProfit.vue?vue&type=style&index=0&id=3ba7986c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../frontend-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ba7986c",
  null
  
)

export default component.exports